import axios from 'axios';
import { API_BASE_URL } from '../utils/constants';

const api = axios.create({
  baseURL: `${API_BASE_URL}/operations`,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Generic CRUD factory
const createCrudEndpoints = (resourceName) => ({
  getAll: async (params = {}) => {
    const response = await api.get(`/${resourceName}/`, { params });
    return response.data;
  },
  getById: async (id) => {
    const response = await api.get(`/${resourceName}/${id}/`);
    return response.data;
  },
  create: async (data) => {
    const response = await api.post(`/${resourceName}/`, data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.patch(`/${resourceName}/${id}/`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`/${resourceName}/${id}/`);
    return response.data;
  },
});

export const operationsService = {
  offers: createCrudEndpoints('offers'),
  enquiries: createCrudEndpoints('enquiries'),
  appointments: createCrudEndpoints('appointments'),
  tenancies: createCrudEndpoints('tenancies'),
  journalEntries: createCrudEndpoints('journal-entries'),
  matchingResults: createCrudEndpoints('matching-results'),
  maintenanceRequests: createCrudEndpoints('maintenance-requests'),
};
